// extracted by mini-css-extract-plugin
module.exports = {"body":"ItemStable_body__1HlGU","card":"ItemStable_card__32AMb","bg":"ItemStable_bg__TmY1t"};